import {
    SiNextdotjs,
    SiReact,
    SiTailwindcss,
    SiTypescript,
    SiNodedotjs,
    SiAdonisjs,
    SiHtml5,
    SiWordpress,
    SiCss3,
    SiJavascript,
    SiAstro,
    SiPhp,
    SiMysql,
    SiHibernate,
    SiPostgresql,
    SiDocker
} from "react-icons/si";
import {FaJava, FaDatabase} from "react-icons/fa";
import {IconType} from "react-icons";

export type ProjectProps = {
  id: number;
  name: string;
  description: string;
  technologies: IconType[];
  techNames: string[];
  techLinks: string[];
  github: string;
  demo: string;
  image: string;
  available: boolean;
};

export const projects = [
    {
        id: 0,
        name: "Pulseo",
        description:
            "Outil d'analyse de performance pour comptes TikTok. Les créateurs renseignent leur handle pour obtenir un score, des insights sur les raisons de sous-performance et trois recommandations actionnables pour améliorer leur contenu.",
        technologies: [SiNextdotjs, SiReact, SiTailwindcss, SiTypescript, SiPostgresql, SiDocker],
        techNames: ["Next.js", "React", "Tailwind CSS", "TypeScript", "PostgreSQL", "Docker"],
        techLinks: ["https://nextjs.org/", "https://reactjs.org/", "https://tailwindcss.com/", "https://www.typescriptlang.org/", "https://www.postgresql.org/", "https://www.docker.com/"],
        github: "",
        demo: "https://trypulseo.com/",
        image: "/projects/pulseo.png",
        available: true,
    },
    {
        id: 1,
        name: "Lummy",
        description:
            "SaaS qui transforme des photos classiques prises au téléphone en visuels travaillés et professionnels grâce à l'IA. Idéal pour les réseaux sociaux, les communautés et les campagnes marketing.",
        technologies: [SiNextdotjs, SiReact, SiTailwindcss, SiTypescript],
        techNames: ["Next.js", "React", "Tailwind CSS", "TypeScript"],
        techLinks: ["https://nextjs.org/", "https://reactjs.org/", "https://tailwindcss.com/", "https://www.typescriptlang.org/"],
        github: "",
        demo: "https://lummy.fr/",
        image: "/projects/lummy.png",
        available: true,
    },
    {
        id: 2,
        name: "NX Jets",
        description:
            "Site vitrine pour un courtier en jets privés basé à Dubaï. Location d'avions privés à la demande, empty legs, jet cards et services de conciergerie haut de gamme avec un réseau de plus de 1000 appareils.",
        technologies: [SiNextdotjs, SiReact, SiTailwindcss, SiTypescript],
        techNames: ["Next.js", "React", "Tailwind CSS", "TypeScript"],
        techLinks: ["https://nextjs.org/", "https://reactjs.org/", "https://tailwindcss.com/", "https://www.typescriptlang.org/"],
        github: "",
        demo: "https://nx-jets.com/",
        image: "/projects/nx-jets.png",
        available: true,
    },
    {
        id: 3,
        name: "Platform",
        description:
            "Landing page pour une startup de Station F spécialisée dans les formations en intelligence artificielle générative. Workshops interactifs couvrant ChatGPT, Claude, Midjourney et autres outils IA.",
        technologies: [SiAstro, SiReact, SiTailwindcss, SiTypescript],
        techNames: ["Astro", "React", "Tailwind CSS", "TypeScript"],
        techLinks: ["https://astro.build/", "https://reactjs.org/", "https://tailwindcss.com/", "https://www.typescriptlang.org/"],
        github: "",
        demo: "https://platformeduction.com/",
        image: "/projects/platform.png",
        available: true,
    },
    {
        id: 4,
        name: "Z#BRE",
        description:
            "Contribution au développement du site vitrine de l'entreprise Z#BRE. Implémentation de fonctionnalités sur mesure, travaillé sur l'optimisation du référencement et des performances du site.",
        technologies: [SiWordpress, SiHtml5, SiCss3, SiJavascript],
        techNames: ["Wordpress", "HTML", "CSS", "Javascript"],
        techLinks: ["https://wordpress.org/", "https://html.com/", "https://css.com/", "https://javascript.com/"],
        github: "",
        demo: "https://zbre.io/",
        image: "/projects/zbre.png",
        available: true,
    },
    {
        id: 5,
        name: "Qwwiz",
        description:
            "Plateforme éducative qui automatise la création et correction d'exercices, détecte les difficultés des élèves selon le référentiel RNCP et permet un suivi personnalisé en temps réel.",
        technologies: [SiNextdotjs, SiReact, SiTailwindcss, SiNodedotjs, SiTypescript, SiAdonisjs],
        techNames: ["Next.js", "React", "Tailwind CSS", "Node.js", "TypeScript", "Adonis"],
        techLinks: ["https://nextjs.org/", "https://reactjs.org/", "https://tailwindcss.com/", "https://nodejs.org/", "https://www.typescriptlang.org/", "https://adonisjs.com/"],
        github: "",
        demo: "https://qwwiz.com/",
        image: "/projects/qwwiz.png",
        available: true,
    },
    {
        id: 6,
        name: "G Mon Stage",
        description:
            "Plateforme permettant aux écoles de gérer leurs étudiants et leurs recherches de stage. Offre des outils d'aide à la création de CV, lettres de motivation et un suivi personnalisé des candidatures.",
        technologies: [SiNextdotjs, SiReact, SiTailwindcss, SiNodedotjs, SiTypescript, SiAdonisjs],
        techNames: ["Next.js", "React", "Tailwind CSS", "Node.js", "TypeScript", "Adonis"],
        techLinks: ["https://nextjs.org/", "https://reactjs.org/", "https://tailwindcss.com/", "https://nodejs.org/", "https://www.typescriptlang.org/", "https://adonisjs.com/"],
        github: "",
        demo: "",
        image: "/projects/gmonstage.png",
        available: true,
    },
    {
        id: 7,
        name: "G Mon Avenir",
        description:
            "Plateforme qui facilite la recherche d'alternances pour les étudiants, avec un algorithme qui détecte les offres avec peu de candidats et optimise le CV pour passer les filtres automatisés.",
        technologies: [SiNextdotjs, SiReact, SiTailwindcss, SiNodedotjs, SiTypescript, SiAdonisjs],
        techNames: ["Next.js", "React", "Tailwind CSS", "Node.js", "TypeScript", "Adonis"],
        techLinks: ["https://nextjs.org/", "https://reactjs.org/", "https://tailwindcss.com/", "https://nodejs.org/", "https://www.typescriptlang.org/", "https://adonisjs.com/"],
        github: "",
        demo: "https://gmonavenir.fr/",
        image: "/projects/gmonavenir.png",
        available: true,
    },
];

export const btsProjects: ProjectProps[] = [
    {
        id: 0,
        name: "PhoneLab",
        description:
            "Plateforme e-commerce pour la vente de smartphones neufs et reconditionnés. Catalogue produits, panier, gestion des commandes et back-office d'administration.",
        technologies: [SiHtml5, SiCss3, SiJavascript, SiPhp, SiMysql],
        techNames: ["HTML", "CSS", "JavaScript", "PHP", "MySQL"],
        techLinks: ["https://html.com/", "https://css.com/", "https://javascript.com/", "https://www.php.net/", "https://www.mysql.com/"],
        github: "",
        demo: "",
        image: "/projects/phonelab.png",
        available: true,
    },
    {
        id: 1,
        name: "TaskFlow",
        description:
            "Application desktop de gestion de tâches pour TPE et indépendants. Création, classification par statut et visualisation d'avancement à travers plusieurs vues.",
        technologies: [FaJava, FaJava, SiHibernate, FaDatabase],
        techNames: ["Java", "JavaFX", "Hibernate", "H2"],
        techLinks: ["https://www.java.com/", "https://openjfx.io/", "https://hibernate.org/", "https://www.h2database.com/"],
        github: "",
        demo: "",
        image: "/projects/taskflow.png",
        available: true,
    },
    ...projects.map((p) => ({...p, id: p.id + 2})),
];